var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"count-down-btn",attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.stopPropagation();return _vm.handleClicked.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.message || _vm.initTip))])
}
var staticRenderFns = []

export { render, staticRenderFns }